import {Component, EventEmitter, Output, ChangeDetectionStrategy} from '@angular/core';
import {SharedModule} from '../../ui-components/shared.module';

@Component({
    selector: 'vw-close-btn',
    imports: [
        SharedModule
    ],
    templateUrl: './close-btn.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './close-btn.component.scss'
})
export class CloseBtnComponent {
  @Output() close = new EventEmitter();
  closeClicked() {
    this.close.emit();
  }
}
